import React from 'react'

const CookieToggle = ({
  checked = false,
  disabled = false,
  onChange,
  sectionLabel,
  title,
  description,
  status,
}) => {
  const handleToggle = () => {
    if (disabled) {
      return
    }

    onChange?.(!checked)
  }

  return (
    <div className={`cookie-toggle${checked ? ' is-on' : ''}${disabled ? ' is-disabled' : ''}`}>
      <div className="cookie-toggle__section">{sectionLabel}</div>
      <div className="cookie-toggle__title">{title}</div>
      <div className="cookie-toggle__actions">
        {status && <span className="cookie-toggle__status">{status}</span>}
        <button
          type="button"
          className="cookie-toggle__switch"
          role="switch"
          aria-checked={checked}
          aria-disabled={disabled}
          disabled={disabled}
          onClick={handleToggle}
        >
          <span className="cookie-toggle__thumb" />
        </button>
      </div>
      <div
        className="cookie-toggle__description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  )
}

export default CookieToggle
